import React from 'react';
import { Container } from "shards-react";
import logo from '../assets/images/vibinoLogo.svg';
import LoginForm from '../components/Login/LoginForm'



const Login = () => (
    <Container fluid className="main-content-container px-4 pb-4">
        <div className="login">
            <div className="login__content">
                <div className="header">
                    <img className="logo" src={logo} alt="Monda" />
                    <h3>Operator Panel</h3>
                </div>
                <LoginForm />
            </div>
        </div>
    </Container>
);

export default Login;
